function hulkappsModalFormInit() {
  let is_form_submit = false;
  const modal = document.querySelector('.hulk-modal');
  const exitModal = document.querySelector('.hulk-modal span.close');

  function showModal() {
    modal.style.display = 'flex';
    document.querySelector('html').classList.add('prevent_scroll');
  }

  function hideModal() {
    modal.style.display = 'none';
    document.querySelector('html').classList.remove('prevent_scroll');
  }

  exitModal.addEventListener('click', hideModal);

  // Close the modal if the user clicks outside of it
  document.addEventListener('click', (e) => {
    if (e.target == modal) hideModal();
  });

  // Listen for checkout buttons and check the cart when clicked
  document.body.addEventListener('click', (e) => {
    if (e.target.closest('button[name="checkout"], input[name="checkout"]') && !is_form_submit) {
      e.preventDefault();
      checkCart();
      console.log('Checking cart - Default prevented');
    }
  }, true);

  // Check the cart to see if products with specific properties are present
  async function checkCart() {
    console.log('Inside checkCart');
    let foundTags = new Array();
    const hulkForm = document.querySelector('#hulk-modal .pxFormGenerator iframe');

    // Fetch the cart data from Shopify
    await fetch('/cart.js')
      .then(res => res.json())
      .then(cart => cart.items.forEach((item) => {
        // Check if the item has the required '_approval_needed' property
        if (item.properties && item.properties.hasOwnProperty('_approval_needed')) {
          foundTags.push(item.properties['_approval_needed']);
          console.log('Product has approval tag', foundTags);
          const hook = setInterval(()=>{
            console.log('Passing to form');
            hulkForm.contentWindow.postMessage({ products: foundTags }, '*');
          },500);
          window.addEventListener('message',(e)=>{
            if (e.data.received){
              console.log('Product tags passed to form: ', e.data.received);
              clearInterval(hook);
            }
          });

          // Inject the corresponding form based on the product property
          if (item.properties['_approval_needed'] === 'rx-obagi-hydroquinone') {
            showForm('eIHRi1E31rjr28ZzmMM58Q');  // Form ID for rx-obagi-hydroquinone
          } else if (item.properties['_approval_needed'] === 'rx-obagi-tretinoin') {
            showForm('PLBERkOGy3o6ROwFLd9vmA');  // Form ID for rx-obagi-tretinoin
          } else if (item.properties['_approval_needed'] === 'rx-upneeq') {
            showForm('SbAUGc0CiyCcRJYGTzxe6A');  // Form ID for rx-upneeq
          } else if (item.properties['_approval_needed'] === 'rx-latisse') {
            showForm('ygw0zksI1_WwHGVdLNlIUw');  // Form ID for rx-latisse
          }
        }
      }));

    // If any tags are found, show the modal with the form
    if (foundTags.length > 0) {
      showModal();
    } else {
      // If no matching items, simulate form submission or close modal
      is_form_submit = true;
      console.log("No matching products found");
      hideModal();  // Optionally hide the modal if no matching items are found
      e.target.click();
    }
  }

  // Show the form in the modal
  function showForm(formId) {
    var modal = document.getElementById('hulk-modal');
    var formToShow = document.getElementById(formId);
    console.log('testttt', formToShow);

    // Hide all forms first
    var allForms = document.querySelectorAll('.pxFormGenerator');
    allForms.forEach(function(form) {
      form.style.display = 'none';
    });

    // Show the specific form
    formToShow.style.display = 'block';

    // Add a form submit listener to handle redirect after form submission
    formToShow.addEventListener('submit', handleFormSubmit);
  }

  // Handle form submission and proceed to checkout
  function handleFormSubmit(event) {
    event.preventDefault();

    // Simulate form submission
    console.log('Form submitted');

    // Close the modal after form submission
    hideModal();

    // Trigger the checkout redirect after form submission
    window.location.href = '/checkout';
  }
}

// Initialize the modal form functionality when the page loads
document.addEventListener('DOMContentLoaded', hulkappsModalFormInit);

// Close the modal when receiving the close message
window.addEventListener("message", (event) => {
  if (event.data === "close_modal") {
    const modal = document.querySelector('.hulk-modal');
    modal.style.display = 'none';
  }
});